import { Fragment, h } from 'preact';
import { useState } from 'preact/hooks';
import './faq.scss';


export function FaqAnswerPlacement(props : any){
  const handleEmptyLine = props?.msgData?.hostInstance?.rootService?.handleEmptyLine;
  const [faq, setFaq] = useState(props.msgData?.faq);
  return (
    <Fragment>
      {faq.answer && faq?.answer?.length > 0 && ((faq.toggle && !faq.answerRender) || faq.answerRender) && (
            faq?.answer?.map((ansObj: any, ii: any) => (
              <div className={"suggestion-body-faq aa-each-suggestion-faq-body " + (ii <= 0 ? '' : 'aa-hidden')} key={ii}>
                <p className="aa-desc-xs suggestion-paragraph" dangerouslySetInnerHTML={{ __html: handleEmptyLine(ansObj['ans'], false, 'faq')}}></p>
                <div className="more-links-buttons aa-seemore-buttons aa-hidden">
                    <button className="more-link-text aa-text-xs aa-more-button"  role="link">{props?.hostInstance?.languagedata?.MORE_TEXT}</button>
                </div>
              </div>
            ))
        )}
    </Fragment>
  )
}

export function FaqExpandCloseBtn(props: any) {
  const languageData = props?.hostInstance?.languagedata
  return (
    <div className="more-links-buttons">
      <button className="more-link-text aa-text-xs expand-link aa-close-btn-link aa-hidden" role="link">{languageData?.CLOSE_TEXT}</button>
      <button className="more-link-text aa-text-xs expand-link aa-expand-btn-link" role="link">{languageData?.EXPAND_MORE}</button>
    </div>
  )
}

export function FAQSendCopyActionButtons(props: any) {
  return (
    <>
    {!props?.msgData?.rootServiceInstance?.hideActionButtons && (
    <div className={"action-buttons aa-action-buttons " + (props?.msgData?.addHideClass ? 'aa-hidden' : '')}>
      {!props?.msgData?.rootServiceInstance?.hideCopyButton && (
        <button className="aa-solidbtn aa-copy-btn-suggestion" aria-label="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_9506_130502)">
              <path d="M10.6663 10.6663V12.533C10.6663 13.2797 10.6663 13.6531 10.521 13.9383C10.3932 14.1892 10.1892 14.3932 9.93833 14.521C9.65311 14.6663 9.27974 14.6663 8.53301 14.6663H3.46634C2.7196 14.6663 2.34624 14.6663 2.06102 14.521C1.81014 14.3932 1.60616 14.1892 1.47833 13.9383C1.33301 13.6531 1.33301 13.2797 1.33301 12.533V7.46634C1.33301 6.7196 1.33301 6.34624 1.47833 6.06102C1.60616 5.81014 1.81014 5.60616 2.06102 5.47833C2.34624 5.33301 2.7196 5.33301 3.46634 5.33301H5.33301M7.46634 10.6663H12.533C13.2797 10.6663 13.6531 10.6663 13.9383 10.521C14.1892 10.3932 14.3932 10.1892 14.521 9.93833C14.6663 9.65311 14.6663 9.27974 14.6663 8.53301V3.46634C14.6663 2.7196 14.6663 2.34624 14.521 2.06102C14.3932 1.81014 14.1892 1.60616 13.9383 1.47833C13.6531 1.33301 13.2797 1.33301 12.533 1.33301H7.46634C6.7196 1.33301 6.34624 1.33301 6.06102 1.47833C5.81014 1.60616 5.60616 1.81014 5.47833 2.06102C5.33301 2.34624 5.33301 2.7196 5.33301 3.46634V8.53301C5.33301 9.27974 5.33301 9.65311 5.47833 9.93833C5.60616 10.1892 5.81014 10.3932 6.06102 10.521C6.34624 10.6663 6.7196 10.6663 7.46634 10.6663Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_9506_130502">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </button>
      )}
      {!props?.msgData?.rootServiceInstance?.hideSendButton && (
        <button className="aa-solidbtn aa-text-xxs aa-send-btn-suggestion" aria-label="button">
          {props?.hostInstance?.languagedata?.SEND}
        </button>
      )}
    </div>
    )}
    </>
  )
}

export function FAQSuggestion(props: any) {

  const handleEmptyLine = props?.msgData?.hostInstance?.rootService?.handleEmptyLine;

  return (
    <div>
      {props?.msgData?.faqs?.map((faq: any, i: any) => (
        <div className={"suggestion-item-card aa-each-suggestion " + (i < props?.msgData?.viewCount ? '' : 'aa-hidden')} key={i}>
          <div className="suggestion-header-faq aa-suggestion-header">

            <div className="titles-info-sec aa-suggestion-title">
              {(!faq.displayName || faq.question) && (
                <h2 className="aa-text-xs semibold text-truncate">{faq.displayName || faq.question}</h2>
              )}

              {faq.answer && faq?.answer?.length > 1 &&
                ((!faq.seeMoreWrapper && faq.answerRender) || (faq.toggle && !faq.answerRender && !faq.seeMoreWrapper)) && (
                  <span className="aa-faq-ans-length">1/{faq?.answer?.length}</span>
                )}

              {faq.childBotName && <span className="aa-desc-sm semibold child-bot-name text-truncate">({faq.childBotName})</span>}
              <span className={"up-down-arrows aa-faq-down-arrow " + (!faq.answerRender && !faq.toggle ? '' : 'aa-hidden')}>
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.36437 10.3494C8.17497 10.5383 7.87481 10.5494 7.67239 10.3828L7.63563 10.3494L3.15093 6.07722C2.94969 5.87653 2.94969 5.55115 3.15093 5.35047C3.34033 5.16158 3.64048 5.15047 3.84291 5.31713L3.87967 5.35047L8 9.25923L12.1203 5.35047C12.3097 5.16158 12.6099 5.15047 12.8123 5.31713L12.8491 5.35047C13.0385 5.53935 13.0496 5.83868 12.8825 6.04056L12.8491 6.07722L8.36437 10.3494Z" fill="#9AA4B2"/>
                </svg>
              </span>
              <span className={"up-down-arrows aa-faq-up-arrow " + (!faq.answerRender && faq.toggle ? '' : 'aa-hidden')}>
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.63563 5.35054C7.82503 5.16166 8.12519 5.15055 8.32761 5.31721L8.36437 5.35054L12.8491 9.6227C13.0503 9.82338 13.0503 10.1488 12.8491 10.3494C12.6597 10.5383 12.3595 10.5494 12.1571 10.3828L12.1203 10.3494L8 6.44074L3.87967 10.3494C3.69027 10.5383 3.39012 10.5494 3.18769 10.3828L3.15093 10.3494C2.96153 10.1606 2.95039 9.86123 3.1175 9.65936L3.15093 9.6227L7.63563 5.35054Z" fill="#9AA4B2"/>
                </svg>
              </span>

              <div id="loader" className="loader-progress-individual aa-faq-answer-loader aa-hidden">
                    <div className="loading-border"></div>
              </div>

            </div>
          </div>

          {faq.answer && faq?.answer?.length > 0 && ((faq.toggle && !faq.answerRender) || faq.answerRender) && (
            faq?.answer?.map((ansObj: any, ii: any) => (
              <div className={"suggestion-body-faq aa-each-suggestion-faq-body "} key={ii}>
                <p className="aa-desc-xs suggestion-paragraph" dangerouslySetInnerHTML={{ __html: handleEmptyLine(ansObj['ans'], false, 'faq') }}></p>
                <div className="more-links-buttons aa-seemore-buttons aa-hidden">
                    <button className="more-link-text aa-text-xs aa-more-button"  role="link">{props?.hostInstance?.languagedata?.MORE_TEXT}</button>
                </div>
              </div>
            ))
          )}
        </div>
      ))}
    </div>
  );
}
